import type { SeriesStreakItem } from '@/components/Series/SeriesStreakBar/internal/types'

export default function getCurrentStreak(items: SeriesStreakItem[]) {
  const pastSessions = items.filter(item => item.hasEnded)

  let currentStreak = 0
  if (pastSessions.length > 0) {
    for (let i = pastSessions.length - 1; i >= 0; i -= 1) {
      if (pastSessions[i].attended === true) {
        currentStreak += 1
      } else {
        break
      }
    }
  }

  return currentStreak
}
